module.exports = __webpack_public_path__ + "static/img/icon_rjyf_rjfw_aq.69ecc67f.png";